import React, {Component, ReactNode} from "react"
import styled from "styled-components"
import {Body} from "@irati/ui/src/Typography"
import DisplayIcon from "@irati-web/recognition/src/components/WhoRewarded/DisplayIcon"

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
`

interface Props {
  leftText: string
  rightText: ReactNode
  rewardType?: string
}

class Row extends Component<Props> {
  static defaultProps = {
    rewardType: null
  }

  render() {
    const {leftText, rightText, rewardType} = this.props
    return (
      <FlexRow>
        {rewardType ? (
          <IconWrapper>
            <DisplayIcon rewardType={rewardType} />
            <Body small marginBottom={0.5} marginTop={0.5}>
              {leftText}
            </Body>
          </IconWrapper>
        ) : (
          <Body small marginBottom={0.5} marginTop={0.5}>
            {leftText}
          </Body>
        )}
        <Body small marginBottom={0.5} marginTop={0.5} textAlign="right">
          {rightText}
        </Body>
      </FlexRow>
    )
  }
}

export default Row
